module.exports = __webpack_public_path__ + "img/03.76ea83c9.png";